import React from 'react'
import {AiOutlineFolderAdd} from "react-icons/ai"
import {Link} from "react-router-dom"
const AddTaskCard = () => {
  return (
    <Link to={'/create'} className="bg-[#0e0e0e] py-8 px-3 rounded-xl text-white w-full max-w-md flex flex-col items-center justify-center">
      <AiOutlineFolderAdd className="text-gray-500 h-12 w-auto font-light" />
      <div className=" font-medium mt-3 text-center">
        <p> No task to display </p>
        <p>Add new Task</p>
      </div>
    </Link>
  )
}

export default AddTaskCard
